import React from 'react';
import { Link } from 'react-router-dom';
import {history} from '../routers/AppRouter';
import {connect} from 'react-redux';
import API from './api';
import selectWorks from '../selectors/works'
import WorkDetailsHeader from './WorkDetailsHeader';
import PhotoAlbum from './PhotoAlbum';
import ScrollArea from 'react-scrollbar';
import posed from 'react-pose';
import PageAnimation from '../components/PageTransitions';

const BoxHero = posed.div({
  visible: { 
    x: 0,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    x: 50,
    opacity: 0,
    transition: { duration: 600 }
  }
});

class WorkDetailsPage extends React.Component{
  state = {
    isHeroVisible:false,
    pageExists:false,
    nextProject:"none",
    title:'',
    logourl:'',
    fields:[],
    hero_image_default:'/images/empty_heropng.png',
    hero_image:'',
    content:'',
    gallary:[],
    facebookUrl:'',
    instaUrl:'',
    linkedinUrl:'',
    youtubeUrl:'',
    behanceUrl:'',
    pinterestUrl:'',
    twitterUrl:'',
  };
  componentWillMount = () =>{
    
    const pageID = this.props.match.params.id;
    const allWorks = this.props.works
    //Test if page exists
    if (allWorks.filter(function(e) { return e.id === pageID; }).length > 0) {
      
      const thisWork = allWorks.filter(function(e) { 
        return e.id === pageID; 
      });
      API.get(`singel_work/${thisWork[0].project_id}`)
      .then(res => {
        const workdetails = res.data;
        this.setState({
          gallary:workdetails.gallary,
          title:workdetails.title,
          logourl:workdetails.logourl,
          fields:workdetails.fields,
          hero_image:workdetails.hero_image,
          content:workdetails.content,
        });
      });

      if (this.props.settingsData.dataIn){
        // if data stored on Redux
        this.setState({
          facebookUrl:this.props.settingsData.facebook,
          instaUrl:this.props.settingsData.instagram,
          linkedinUrl:this.props.settingsData.linkedin,
          youtubeUrl:this.props.settingsData.youtube,
          behanceUrl:this.props.settingsData.behance,
          pinterestUrl:this.props.settingsData.twitter,
          twitterUrl:this.props.settingsData.pinterest,
        });
      } else{
        // if data not stored on Redux try to fetch again
        API.get(`settings`)
        .then(res => {
          const settings = res.data;
          this.setState({
            facebookUrl:settings.facebook,
            instaUrl:settings.instagram,
            linkedinUrl:settings.linkedin,
            youtubeUrl:settings.youtube,
            behanceUrl:settings.behance,
            pinterestUrl:settings.twitter,
            twitterUrl:settings.pinterest,
          });
        });
      }
      
      this.setState({pageExists:true})
    } else{
      //console.log("false");
      location.pathname = "/notfound";
    }

    //get next project
    const currentProject = allWorks.filter(function(e) { return e.id === pageID; })
    const nextProject = allWorks.indexOf(currentProject[0]) +1;
    if ( nextProject < allWorks.length ){
      this.setState({nextProject:allWorks[nextProject].id});
    } else{
      this.setState({nextProject:allWorks[0].id});
    }
    

  };

  handelHeroLoad = () =>{
    this.setState({ isHeroVisible: true });
  }

  render(){
      return(
        <div>
          {this.state.pageExists ? 
          <PageAnimation frompage={history.location.state.prevPath} topage={history.location.pathname} animP="/details">
          <ScrollArea
            smoothScrolling={true}
            onScroll={() => {
              document.querySelector(".logo").classList.remove("home");
            }}
            className="workDetailsPage"
            verticalContainerStyle={{background:"#cccccc"}}
            verticalScrollbarStyle={{background:"#ffffff"}}
            horizontal={false}
            >
            <div className="fixedNav">
              <Link className="back" to={{pathname: '/about', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> About</Link>
              <Link className="current" to={{pathname: '/work', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> Work</Link>
            </div>
          <WorkDetailsHeader logoUrl={this.state.logourl} name={this.state.title} filds={this.state.fields} />
          {/*  
            <div className="scrollExploreMore">
              <p>Scroll to explore more</p>
              <span className="button socialIcon" onClick={this.handelScrollTo}><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"></span></span>
            </div>
          */}
            <div className="heroImage">
              <div className="bContainer">
              {
                !this.state.isHeroVisible && <img className="heroImageLoading" src="/images/loader.gif" />
              }
                <BoxHero className="head"
                  pose={this.state.isHeroVisible ? 'visible' : 'hidden'}
                >
                  {this.state.hero_image ? 
                    <img onLoad={this.handelHeroLoad} src={this.state.hero_image}  alt={this.state.title} />
                  :
                    <img src={this.state.hero_image_default}  alt={this.state.title} />
                  }
                  
                </BoxHero>
              </div>
            </div>
            <div className="projectInfo">
              <div className="bContainer">
              <div dangerouslySetInnerHTML={{__html: this.state.content}}/>
              </div>
            </div>
            <div className="bContainer">
              {this.state.gallary.length !== 0 ? 
                <PhotoAlbum title={this.state.title} gallery={this.state.gallary} id={this.props.match.params.id} />
                :
                <p></p>
              }
              <div className="getInTouch">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="title">
                      <p><strong>Interested</strong>, and have something on your mind? </p>
                      <h1>Let's work on your project.</h1>
                      <Link className="button pink" to={{pathname: '/contact', state: { prevPath: location.pathname }}}>Request a quote</Link>
                    </div>
                  </div>
                  <div className="col-sm-6 social">
                    <div className="title">
                      <p>Get in touch with us</p>
                    </div>
                    <p>
                    {this.state.facebookUrl && <a className="button socialIcon" href={this.state.facebookUrl} target="_blank"><span className="icon-facebook"></span></a>}
                    {this.state.instaUrl && <a className="button socialIcon" href={this.state.instaUrl} target="_blank"><span className="icon-instagram"></span></a>}
                    {this.state.linkedinUrl && <a className="button socialIcon" href={this.state.linkedinUrl} target="_blank"><span className="icon-linkedin"></span></a>}
                    {this.state.youtubeUrl && <a className="button socialIcon" href={this.state.youtubeUrl} target="_blank"><span className="icon-youtube-play"></span></a>}
                    {this.state.behanceUrl && <a className="button socialIcon" href={this.state.behanceUrl} target="_blank"><span className="icon-behance"></span></a>}
                    {this.state.pinterestUrl && <a className="button socialIcon" href={this.state.pinterestUrl} target="_blank"><span className="icon-pinterest-p"></span></a>}
                    {this.state.twitterUrl && <a className="button socialIcon" href={this.state.twitterUrl} target="_blank"><span className="icon-twitter"></span></a>}
                      <Link className="button socialIcon" to={{pathname: '/contact', state: { prevPath: location.pathname }}}><span className="icon-at"></span></Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="pageNav">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="left">
                      <Link className="back" to={{pathname: '/work', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> Back to projects</Link>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="right">
                      <Link className="back" to={{pathname: `${this.state.nextProject}`, state: { prevPath: location.pathname }}}>Next project <span className="icon-back-right"></span></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollArea>
          </PageAnimation>
          : <p></p>}
        </div>
    );
  }
}

const mapStateToProps = (state) =>{
  return{
      works: selectWorks(state.works, state.filters),
      settingsData: state.settings
  };
};

export default connect(mapStateToProps)(WorkDetailsPage);



// WEBPACK FOOTER //
// ./src/components/WorkDetailsPage.js